import React from "react";
import cx from "classnames";
import { IAudioModel } from "shared-types";
import {
  formatTime,
  transformMillisecToSec,
} from "../../../../../generics/time-formatting";
import { ExpandableFileName } from "../../../../Atoms/ExpandableFileName/ExpandableFileName";

import "./AudioTrack.scss";

export interface IAudioTrackProps {
  isActive: boolean;
  track: IAudioModel;
  selectTrack: (track: IAudioModel) => void;
  fileNameLength?: number;
}

export const AudioTrack: React.FC<
  React.PropsWithChildren<IAudioTrackProps>
> = ({ track, isActive, selectTrack, fileNameLength }) => {
  const trackRowClasses = cx({
    "c-audio-track": true,
    "c-audio-track--active": isActive,
  });

  const selectTrackWrapper = () => selectTrack(track);

  return (
    <li className={trackRowClasses} onClick={selectTrackWrapper}>
      <i className="c-audio-track__icon icon-controlsPlay" />
      <div className="c-audio-track__name">
        <ExpandableFileName
          fileName={track.fileName}
          fileNameLength={fileNameLength}
          spanClassName="c-audio-track__title-filename"
          spanExpandedClassName="c-audio-track__title-filename c-audio-track__title-filename--expanded"
          toggleClassName="c-audio-track__file-name-toggle"
        />
      </div>
      <div className="c-audio-track__duration">
        {formatTime(transformMillisecToSec(track.duration), ".")}
      </div>
    </li>
  );
};
